/**
 * Some inputs are invalid and need to be modified before providing to the user.
 * Right now this is only for Select Inputs where they are missing an "empty" value
 * Select inputs should all start with a "Select a ..." option. Without this, if the user
 * selects the first option, the change event is never fired and the input value will
 * not go into state.
 * @param input The input to be fixed
 * @returns The fixed input
 */
export const fixInput = (input) => {
    if (input.__typename !== 'WorkflowSelectInput') {
        return input;
    }
    if (!input.values.length || !input.values[0].value) {
        return input;
    }
    return {
        ...input,
        values: [
            {
                displayValue: 'Select an Option...',
                value: ''
            },
            ...input.values
        ]
    };
};
/**
 * Searches the given errors array for one that matches the given input, and returns that error's
 * message.
 *
 * If none are found, returns `null`. Returns only the first match if multiple exist.
 *
 * @param inputName the name of the input to search for errors.
 * @param errors an array of errors to search.
 */
export const errorMessage = (inputName, errors) => {
    const matched = errors.find(e => e.input === inputName);
    return matched && matched.message || null;
};
/**
 * Searches the given errors array for matches without input value, and returns those errors'
 * messages.
 *
 * If none are found, returns `[]`.
 *
 * @param errors an array of errors to search.
 */
export const nonInputErrorMessages = (errors) => errors.filter(e => !e.input && e.message)
    .map(e => e.message);
export const GATEWAY_ERROR = 'wfjs_payment_gateway_error';
export const GENERIC_ERROR = 'wfjs_generic_error';
/**
 * When we submit, we can receive errors from Payment Gateway (failed to tokenize),
 * or from Avant Basic (didn't accept tokenized card). These errors are populated
 * in different places, but have to both be considered 'nonInputErrors' for `renderStep`
 * to display them in the same way.
 *
 * This method merges those two error sources into one object to use within `renderStep`.
 *
 * @param stepErrors the error message parsed or generated within the custom debit card step
 * @param workflowErrors the collection of error objects from a runworkflow response
 * @returns an array of all errors received from services or generated within the step, _not_ associated with an input
 */
export const mergeServerErrors = (stepErrors, workflowErrors) => {
    const gatewayError = stepErrors.get(GATEWAY_ERROR);
    const genericError = stepErrors.get(GENERIC_ERROR);
    return [
        ...(gatewayError ? [gatewayError] : []),
        ...(genericError ? [genericError] : []),
        ...workflowErrors
    ];
};
